import React from "react"

export default function ProfilePhoto(){
    return (
        <div>
                
        </div>
    );
}